<template>
  <div id="wrapper" class="gray-bg login-bg">
    <div class="container">
      <div class="row">
        <div class="col-sm-offset-2 col-sm-8 col-md-offset-3 col-md-6">
          <div class="login">
            <div class="logo">
              <h1>Account Details</h1>
            </div>

            <div class="panel-group panel-group-stepper" id="details" role="tablist" aria-multiselectable="true" v-collapse-stepper>
              <form role="form" data-vv-scope="account-details" class="panel">
                  <div class="panel-heading" role="tab" id="headingOne">
                    <h4 class="panel-title">
                      <a role="button" data-toggle="collapse" data-parent="#details" href="#account-details" aria-expanded="true" aria-controls="account-details">
                        <span class="stepper-number stepper-active" :class="{ 'stepper-error': errors.any('account-details') }">1</span> Account Details
                      </a>
                    </h4>
                  </div>
                  <div id="account-details" class="panel-collapse collapse in" role="tabpanel" aria-labelledby="headingOne">
                    <div class="panel-body">

                      <div class="form-group-outer">
                        <div class="form-group float-label-control form-group" :class="{ 'has-error': errors.has('account-details.first_name') }">
                          <label for="">First Name</label>
                          <input v-model="name" v-validate="'required'" name="first_name" type="text" class="form-control" placeholder="First Name" v-float-label/>
                        </div>
                      </div><!-- /.form-group-outer -->

                      <div class="form-group-outer">
                        <div class="form-group float-label-control form-group" :class="{ 'has-error': errors.has('account-details.surname') }">
                          <label for="">Surname</label>
                          <input v-model="surname" v-validate="'required'" name='surname' type="text" class="form-control" placeholder="Surname" v-float-label/>
                        </div>
                      </div><!-- /.form-group-outer -->

                      <div class="form-group-outer">
                        <div class="form-group float-label-control form-group" :class="{ 'has-error': errors.has('account-details.mobile') }">
                          <label for="">Mobile Number</label>
                          <input v-model="mobile" v-validate="'required'" name="mobile" type="text" class="form-control" placeholder="Mobile Number" v-float-label/>
                        </div>
                      </div><!-- /.form-group-outer -->

                      <div class="text-right">
                        <a class="btn btn-primary" role="button" data-toggle="collapse" data-parent="#details" href="#account-details" aria-controls="account-details" aria-expanded="true" data-target="#company-details">Next</a>
                      </div>
                    </div>
                  </div>
              </form>

              <form role="form" data-vv-scope="company-details" class="panel">
                <div class="panel-heading" role="tab" id="headingTwo">
                  <h4 class="panel-title">
                    <a class="collapsed" role="button" data-toggle="collapse" data-parent="#details" href="#company-details" aria-expanded="false" aria-controls="company-details">
                      <span class="stepper-number" :class="{ 'stepper-error': errors.any('company-details') }">2</span> Company Details
                    </a>
                  </h4>
                </div>
                <div id="company-details" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingTwo">
                  <div class="panel-body">

                    <div class="form-group-outer">
                      <div class="form-group float-label-control form-group" :class="{ 'has-error': errors.has('company-details.company_name') }">
                        <label for="">Entity Name</label>
                        <input v-model="companyName" v-validate="'required'" name="company_name" type="text" class="form-control" placeholder="Entity Name" v-float-label/>
                      </div>
                    </div><!-- /.form-group-outer -->

                    <div class="form-group-outer">
                      <div class="form-group float-label-control form-group" :class="{ 'has-error': errors.has('company-details.company_phone') }">
                        <label for="">Phone Number</label>
                        <input v-model="companyPhone" v-validate="'required'" name="company_phone" type="text" class="form-control" placeholder="Phone Number" v-float-label/>
                      </div>
                    </div><!-- /.form-group-outer -->

                    <div class="form-group-outer">
                      <div class="form-group float-label-control form-group" :class="{ 'has-error': errors.has('company-details.company_abn') }">
                        <label for="">ABN</label>
                        <input v-model="companyAbn" v-validate="'required'" name="company_abn" type="text" class="form-control" placeholder="ABN" v-float-label/>
                      </div>
                    </div><!-- /.form-group-outer -->


                    <div class="text-right">
                      <a class="btn btn-info" role="button" data-toggle="collapse" data-parent="#details" href="#company-details" aria-controls="company-details" aria-expanded="true" data-target="#account-details">Back</a>
                      <a class="btn btn-primary" role="button" data-toggle="collapse" data-parent="#details" href="#company-details" aria-controls="company-details" aria-expanded="true" data-target="#billing-address">Next</a>
                    </div>

                  </div>
                </div>
              </form>

              <form role="form" class="panel" data-vv-scope="billing-address">
                <div class="panel-heading" role="tab" id="headingThree">
                  <h4 class="panel-title">
                    <a class="collapsed" role="button" data-toggle="collapse" data-parent="#details" href="#billing-address" aria-expanded="false" aria-controls="billing-address">
                      <span class="stepper-number" :class="{ 'stepper-error': errors.any('billing-address') }">3</span> Billing Address
                    </a>
                  </h4>
                </div>
                <div id="billing-address" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingThree">
                  <div class="panel-body">

                    <div class="form-group-outer">
                      <div class="form-group float-label-control form-group" :class="{ 'has-error': errors.has('billing-address.address_line_1') }">
                        <label for="">Line 1</label>
                        <input v-model="addressLineOne" v-validate="'required'" name="address_line_1" type="text" class="form-control" placeholder="Line 1" v-float-label/>
                      </div>
                    </div><!-- /.form-group-outer -->

                    <div class="form-group-outer">
                      <div class="form-group float-label-control form-group" >
                        <label for="">Line 2</label>
                        <input v-model="addressLineTwo" type="text" class="form-control" placeholder="Line 2" v-float-label/>
                      </div>
                    </div><!-- /.form-group-outer -->

                    <div class="form-group-outer">
                      <div class="form-group float-label-control form-group" :class="{ 'has-error': errors.has('billing-address.suburb') }">
                        <label for="">Suburb</label>
                        <input v-model="suburb" type="text" v-validate="'required'" name="suburb" class="form-control" placeholder="Suburb"  v-float-label/>
                      </div>
                    </div><!-- /.form-group-outer -->

                    <div class="form-group-outer">
                      <div class="form-group float-label-control form-group" :class="{ 'has-error': errors.has('billing-address.state') }">
                        <label for="" class="select-label">State</label>
                        <selectize
                          v-model="state"
                          v-validate="'required'"
                          name="state"
                          :options="stateOptions"
                          class="form-control select2-material-placeholder">
                        </selectize>
                      </div>
                    </div><!-- /.form-group-outer -->

                    <div class="form-group-outer">
                      <div class="form-group float-label-control form-group" :class="{ 'has-error': errors.has('billing-address.postcode') }">
                        <label for="">Postcode</label>
                        <input v-model="postcode" v-validate="'required'" name="postcode" type="text" class="form-control" placeholder="Postcode"  v-float-label/>
                      </div>
                    </div><!-- /.form-group-outer -->

                    <div class="text-right">
                      <a class="btn btn-info" role="button" data-toggle="collapse" data-parent="#details" href="#billing-address" aria-controls="billing-address" aria-expanded="true" data-target="#company-details">Back</a>

                      <ladda-button v-if="!$user.isCarrier" size="large" :on-click="handleFinishRegistration" type="success">Finish</ladda-button>
                      <a v-else class="btn btn-primary" role="button" data-toggle="collapse" data-parent="#details" href="#billing-address" aria-controls="billing-address" aria-expanded="true" data-target="#payment-details">Next</a>
                    </div>

                  </div>
                </div>
              </form>

              <!-- Carried details panel -->
              <!-- Hide if registering as client -->
              <form role="form" class="panel" data-vv-scope="payment-details" v-if="$user.isCarrier">
                <div class="panel-heading" role="tab" id="headingFour">
                  <h4 class="panel-title">
                    <a class="collapsed" role="button" data-toggle="collapse" data-parent="#details" href="#payment-details" aria-expanded="false" aria-controls="payment-details">
                      <span class="stepper-number" :class="{ 'stepper-error': errors.any('payment-details') }">4</span> Payment Details
                    </a>
                  </h4>
                </div>
                <div id="payment-details" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingFour">
                  <div class="panel-body">

                    <p>To prevent any delays in being paid please enter the bank account details you would like to be paid into. This area is optional and can be completed later.</p>

                    <div class="margin-20"></div>

                    <div class="form-group-outer">
                      <div class="form-group float-label-control form-group" :class="{ 'has-error': errors.has('payment-details.account_name') }">
                        <label for="">Account Name</label>
                        <input v-model="accountName" name="account_name" type="text" class="form-control" placeholder="Account Name" v-float-label/>
                      </div>
                    </div><!-- /.form-group-outer -->

                    <div class="row">
                      <div class="col-sm-4">
                        <div class="form-group-outer">
                          <div class="form-group float-label-control form-group" :class="{ 'has-error': errors.has('payment-details.bsb') }">
                            <label for="">BSB</label>
                            <input v-model="bsb"  name="bsb" type="text" class="form-control" placeholder="BSB" v-float-label/>
                          </div>
                        </div><!-- /.form-group-outer -->
                      </div>
                      <div class="col-sm-8">
                        <div class="form-group-outer">
                          <div class="form-group float-label-control form-group" :class="{ 'has-error': errors.has('payment-details.account_number') }">
                            <label for="">Account Number</label>
                            <input v-model="accountNumber" name="account_number" type="text" class="form-control" placeholder="Account Number" v-float-label/>
                          </div>
                        </div><!-- /.form-group-outer -->
                      </div>
                    </div><!-- /.row -->

                    <div class="text-right">
                      <a class="btn btn-info" role="button" data-toggle="collapse" data-parent="#details" href="#payment-details" aria-controls="payment-details" aria-expanded="true" data-target="#billing-address">Back</a>
                      <ladda-button size="large" :on-click="handleFinishRegistration" type="success">Finish</ladda-button>
                    </div>

                  </div>
                </div>
              </form>
              <div class="login-footer">
                <div class="row">
                  <div class="col-xs-7">
                    <router-link :to="{ name: 'auth.logout' }"><i class="fa fa-angle-left"></i> Back to Login</router-link>
                  </div>
                </div>
              </div>
            </div><!-- /.panel-group -->
          </div><!-- /.login -->
        </div>
      </div><!-- /.login -->
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import states from 'mixins/states'
  import { stateMapper } from 'mixins/user'
  import { mapActions, mapMutations, mapState } from 'vuex'
  import { LaddaButton, Selectize } from 'components/forms'
  import { SET_USER, SET_USER_ATTRIBUTE } from 'vx/mutations'
  import { forIn, each } from 'lodash'
  import notify from 'utils/notify'

  export default {
    mixins: [states, stateMapper],

    data () {
      return {
        stateProperty: 'user',
        mutationProperty: SET_USER_ATTRIBUTE
      }
    },

    components: {
      LaddaButton,
      Selectize
    },

    mounted () {
      $('body').addClass('pace-top')
    },

    computed: mapState('user', ['user', 'authorized']),

    created () {
      if (this.$user.valid) {
        this.$router.push({ name: 'dashboard' })
      }

      this[SET_USER](this.authorized)
    },

    methods: {
      ...mapActions('user', ['saveRegistrationDetails']),
      ...mapMutations('user', [SET_USER]),

      handleFinishRegistration () {
        return this.validateAll().then(() => {
          const redirectToSuccess = () => (this.$router.push({ name: 'auth.success' }))

          return this.saveRegistrationDetails({ id: this.$user.id, payload: { profile: this.user.profile, mobile: this.user.mobile } })
            .then(redirectToSuccess)
            .catch(exception => {
              if (exception.response && exception.response.status === 422) {
                forIn(exception.response.data.errors, (errors, key) => {
                  if (key === 'mobile') {
                    each(errors, error => {
                      this.errors.add('mobile', error, null, 'account-details')
                      notify.error(error)
                    })
                  }
                })
              }
            })
        })
      }
    }

  }
</script>



// WEBPACK FOOTER //
// RegisterDetails.vue?14fc99b5